import { render } from "./base-info.vue?vue&type=template&id=3ef403fa&scoped=true"
import script from "./base-info.vue?vue&type=script&lang=js"
export * from "./base-info.vue?vue&type=script&lang=js"

import "./base-info.vue?vue&type=style&index=0&id=3ef403fa&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ef403fa"]])

export default __exports__